import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_5 = { class: "shadow-none lh-1 fw-bold ps-0" }
const _hoisted_6 = { class: "shadow-none lh-1 fw-semibold text-black-emphasis" }
const _hoisted_7 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_10 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_11 = {
  key: 1,
  class: "badge text-outline-info"
}
const _hoisted_12 = {
  key: 2,
  class: "badge text-outline-warning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between" }, [
        _createElementVNode("h6", { class: "card-title fw-bold mb-0" }, "Les dix dernières recettes du jour")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              }, " Réf. "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Montant "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Motif "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Statut ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.demandes, (dem, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("th", _hoisted_5, _toDisplayString(dem.refPaiement), 1),
                _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.separateur(dem.montant)) + " FCFA ", 1),
                _createElementVNode("td", _hoisted_7, _toDisplayString(dem.motif), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.format_date(dem.datePaiement)), 1),
                _createElementVNode("td", _hoisted_9, [
                  (dem.statut === 'SUCCESS')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString("SUCCESS")))
                    : (dem.statut === 'RAS')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString("RAS")))
                      : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(dem.statut), 1))
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}